function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isAccordionItemProps, isBaseItemProps, isGroupItemProps, isNextListItemProps } from '@snack-uikit/list';
export function withCollapsedItems(_ref) {
  var items = _ref.items,
    openCollapsedItems = _ref.openCollapsedItems;
  var itemRefs = [];
  var newItems = [];
  var ids = [];
  var expandedIds = [];
  items.forEach(function (item) {
    if ((isBaseItemProps(item) && !item.inactive || isNextListItemProps(item) || isAccordionItemProps(item)) && !item.disabled) {
      var _item$id;
      newItems = newItems.concat([item]);
      ids = ids.concat([(_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : '']);
      if (item.itemRef) {
        itemRefs = itemRefs.concat([item.itemRef]);
      }
    }
    if (isNextListItemProps(item) && item.id && !item.disabled) {
      expandedIds = expandedIds.concat(item.id);
    }
    if (isGroupItemProps(item)) {
      var _withCollapsedItems = withCollapsedItems({
          items: item.items,
          openCollapsedItems: openCollapsedItems
        }),
        nestedItemsRefs = _withCollapsedItems.itemRefs,
        nestedIds = _withCollapsedItems.ids;
      ids = ids.concat(nestedIds);
      itemRefs = itemRefs.concat(nestedItemsRefs);
    }
    if (isAccordionItemProps(item) && item.id && openCollapsedItems.includes(item.id)) {
      var _withCollapsedItems2 = withCollapsedItems({
          items: item.items,
          openCollapsedItems: openCollapsedItems
        }),
        _nestedItemsRefs = _withCollapsedItems2.itemRefs,
        _nestedIds = _withCollapsedItems2.ids,
        nestedItems = _withCollapsedItems2.items,
        nestedExpandedIds = _withCollapsedItems2.expandedIds;
      ids = ids.concat(_nestedIds);
      newItems = newItems.concat(nestedItems);
      itemRefs = itemRefs.concat(_nestedItemsRefs);
      expandedIds = expandedIds.concat(nestedExpandedIds);
    }
  });
  return {
    items: items,
    itemRefs: itemRefs,
    ids: ids,
    expandedIds: expandedIds
  };
}

/**
 * Функция возвращает массив id дочерних items
 * @function  extractItemIds
 */

export function extractItemIds(items) {
  return items.reduce(function (prev, item) {
    if (isGroupItemProps(item)) {
      return prev.concat(extractItemIds(item.items));
    }
    return item.id ? prev.concat([item.id]) : prev;
  }, []);
}
export function extractChildIds(_ref2) {
  var items = _ref2.items;
  return items.filter(function (item) {
    return isAccordionItemProps(item) || isNextListItemProps(item) || isGroupItemProps(item) || isBaseItemProps(item) && !item.disabled && !item.inactive;
  }).reduce(function (prev, item) {
    if (isAccordionItemProps(item) || isNextListItemProps(item)) {
      var _item$id2;
      return prev.concat([(_item$id2 = item.id) !== null && _item$id2 !== void 0 ? _item$id2 : '']).concat(extractChildIds({
        items: item.items
      }));
    }
    if (isGroupItemProps(item)) {
      return prev.concat(extractChildIds({
        items: item.items
      }));
    }
    return item.id && !isGroupItemProps(item) ? prev.concat([item.id]) : prev;
  }, []);
}
export function extractAllChildIds(_ref3) {
  var items = _ref3.items;
  return items.filter(function (item) {
    return isAccordionItemProps(item) || isNextListItemProps(item) || isGroupItemProps(item) || isBaseItemProps(item) && !item.inactive;
  }).reduce(function (prev, item) {
    if (isAccordionItemProps(item) || isNextListItemProps(item)) {
      var _item$id3;
      return prev.concat([(_item$id3 = item.id) !== null && _item$id3 !== void 0 ? _item$id3 : '']).concat(extractAllChildIds({
        items: item.items
      }));
    }
    if (isGroupItemProps(item)) {
      return prev.concat(extractAllChildIds({
        items: item.items
      }));
    }
    return item.id && !isGroupItemProps(item) ? prev.concat([item.id]) : prev;
  }, []);
}

/**
 * Функция разворачивает массив айтемов в плоский список
 *  @function  flattenItems
 */

export function flattenItems(items) {
  var flattenItems = [];
  function flatten(item) {
    if (!isGroupItemProps(item)) {
      flattenItems.push(item);
    }
    if ('items' in item) {
      var _iterator = _createForOfIteratorHelper(item.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nestedItem = _step.value;
          flatten(nestedItem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  var _iterator2 = _createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      flatten(item);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return flattenItems;
}